<div class="terminal-metrics-wrapper ioh-trains-table" [style.left.px]="left" [style.z-index]="zIndex" [id]="terminalUid">
  <div class="terminal-metrics">
    <div class="flex align-items-center justify-content-between gap-20">
      <div class="terminal-name-abbrevation-container">
        <div class="text-style">
          <strong class="text-style"> Trains </strong>
        </div>
      </div>
      <div class="close-button" (click)="closeClicked()">X</div>
    </div>
    <div>
      <div>
        <p class="train-title">Inbound Trains</p>
        <csx-ioh-equipment-info-table [hasHeader]="true" [columns]="inboundTableColumns"
          [dataTable]="displayInboundInfoTableData" [rowClickable]="true" (rowClick)="showTrainCallout($event)"></csx-ioh-equipment-info-table>
      </div>
      <div>
        <p class="train-title">Outbound Trains</p>
        <csx-ioh-equipment-info-table [hasHeader]="true" [columns]="outboundTableColumns"
          [dataTable]="displayOutboundInfoTableData" [rowClickable]="true" (rowClick)="showTrainCallout($event)"></csx-ioh-equipment-info-table>
      </div>
    </div>

  </div>
</div>